import { render, staticRenderFns } from "./URLResult.vue?vue&type=template&id=2792863a&scoped=true&"
import script from "./URLResult.vue?vue&type=script&lang=js&"
export * from "./URLResult.vue?vue&type=script&lang=js&"
import style0 from "./URLResult.vue?vue&type=style&index=0&id=2792863a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2792863a",
  null
  
)

export default component.exports